<template>
    <div ref="rootElement" class="Range" v-bind="scope.range.attributes">
        <div class="Range-input Range-input-from" v-if="( mode === 'input' ) || showInputs">
            <label>
                <span v-if="mode === 'input'">From:</span>
                <input
                    ref="rangeSliderInputFrom"
                    type="number"
                    name="rangeSliderInputFrom"
                    :class="this.class"
                    v-model.number.lazy="fromInputValue"
                    v-on="scope.input.from.listeners"
                >
            </label>
        </div>

        <div v-if="mode !== 'input'" ref="rangeSliderElement" class="Range-slider" @click.self.prevent="handleClick">
            <div
                class="Range-slider-handle"
                :data-value="this.format( this.modelValue.from )"
                :style="this.fromHandlePosition"
                v-bind="scope.handle.attributes"
                @mousedown.self.prevent.stop="handleDrag"
                @touchstart.self.prevent.stop="handleDrag"
            ></div>

            <div
                class="Range-slider-handle"
                :data-value="this.format( this.modelValue.to )"
                :style="this.toHandlePosition"
                v-bind="scope.handle.attributes"
                @mousedown.self.prevent.stop="handleDrag"
                @touchstart.self.prevent.stop="handleDrag"
            ></div>
        </div>

        <div class="Range-input Range-input-to" v-if="( mode === 'input' ) || showInputs">
            <label>
                <span v-if="mode === 'input'">To:</span>
                <input
                    ref="rangeSliderInputTo"
                    type="number"
                    name="rangeSliderInputTo"
                    :class="this.class"
                    v-model.number.lazy="toInputValue"
                    v-on="scope.input.to.listeners"
                >
            </label>
        </div>
    </div>
</template>

<script>
import props    from './utils/props.js';
import emits    from './utils/emits.js';
import watches  from './utils/watches.js';
import methods  from './utils/methods.js';
import computed from './utils/computed.js';

export default
{
    name            : "Range",
    inheritAttrs    : false,
    directives      : {},
    mixins          : [ props, computed, methods, emits, watches ],

    data()
    {
        return (
        {

        })
    },

    created()
    {
        this.emitValue( this.modelValue );
    }
}
</script>

<style lang="scss">
.Range
{
    width: 100%;
    height: var( --range-height );

    display: grid;
    align-items: center;
    grid-template-columns: auto;
    gap: var(--range-gap);

    z-index: 1;

    &:has(.Range-input-from, .Range-input-to)
    {
        grid-template-columns: var(--range-input-width) 1fr var(--range-input-width);
    }

    &.vr-input-mode
    {
        grid-template-columns: 1fr 1fr!important;
    }

    > .Range-slider
    {
        position: relative;

        width: 100%;
        height: 100%;

        overflow: visible;

        user-select: none;

        &:before, &:after
        {
            position: absolute;
            content: "";

            top: 50%;
            left: 0;
            right: 0;

            transform: translateY(-50%);

            height: var(--range-progress-height);

            background: var(--range-progress-background-color);

            z-index: -2;
        }

        &:after
        {
            left: var( --range-selection-left );
            right: var( --range-selection-right );

            background: var(--range-progress-fill-background-color);
        }

        > .Range-slider-handle
        {
            position: absolute;

            top: 50%;
            transform: translateY(-50%);

            height: var(--range-handle-size);
            width: var(--range-handle-size);

            border: var(--range-handle-border);
            border-radius: var(--range-handle-border-radius);

            background: var(--range-handle-background-color);

            box-shadow: var(--elevation-sm-shadow);

            cursor: grab;

            &.vr-show-label:before
            {
                @include font-body-sm-regular;

                content: attr(data-value);

                position: absolute;

                top: -100%;
                left: 50%;
                transform: translate(-50%, -50%);

                color: var(--range-handle-background-color);
                background: var(--range-progress-fill-background-color);

                padding: 0 px(4);
            }

            &:after
            {
                // TODO lepsie poriesit

                position: absolute;
                content: '';
                top: -10px;
                left: -10px;
                right: -10px;
                bottom: -10px;
                background:transparent;
            }
        }
    }

    > .Range-input
    {
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button
        {
            -webkit-appearance: none;

            margin: 0;
        }

        input[type=number]
        {
            -moz-appearance: textfield;
        }
    }
}
</style>